import { writable } from 'svelte/store';

export const routes = writable([]);
export const active = writable({ section: null, sub: null });
